import { render } from "./LinksHub.vue?vue&type=template&id=1ff3dc80&scoped=true"
import script from "./LinksHub.vue?vue&type=script&lang=js"
export * from "./LinksHub.vue?vue&type=script&lang=js"

import "./LinksHub.vue?vue&type=style&index=0&id=1ff3dc80&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ff3dc80"]])

export default __exports__